import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-16l10 16v-16","key":"svg-0"}]]

const IconLetterN = createReactComponent('outline', 'letter-n', 'LetterN', __iconNode);

export default IconLetterN;